import React, { Fragment } from 'react';
import { ContactGroup } from 'C4';

const renderOffices = (offices) => {
  const currentOffices = offices;
  return currentOffices.map((office) => (
    <ContactGroup
      key={Math.ceil(Math.random * 1000000)}
      office={office.office}
      salesRegion={office.salesRegion}
      adressLines={office.adressLines}
      contacts={office.contacts}
    />
  ));
};

function Region({ name, offices }) {
  return (
    <Fragment>
      {renderOffices(offices)}
    </Fragment>
  );
}

export default Region;
